import { render } from "./shippingRequests.vue?vue&type=template&id=5fdf5691&scoped=true"
import script from "./shippingRequests.vue?vue&type=script&lang=js"
export * from "./shippingRequests.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./shippingRequests.vue?vue&type=style&index=1&id=5fdf5691&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdf5691"]])

export default __exports__